import React from 'react';
import Icon from '@/components/AppIcon';

const LoadingState = () => {
return (
<div className="space-y-4">
{[...Array(6)]?.map((_, index) => (
<div key={index} className="bg-card border border-border rounded-lg p-6 animate-pulse">
<div className="flex items-start justify-between mb-4">
<div className="flex items-start space-x-3 flex-1">
<div className="w-12 h-12 bg-muted rounded-lg"></div>
<div className="flex-1 space-y-2">
<div className="h-5 bg-muted rounded w-3/4"></div>
<div className="h-4 bg-muted rounded w-1/2"></div>
<div className="h-3 bg-muted rounded w-2/3"></div>
</div>
</div>
<div className="w-20 h-6 bg-muted rounded-full"></div>
</div>

<div className="space-y-2 mb-4">
<div className="h-3 bg-muted rounded w-full"></div>
<div className="h-3 bg-muted rounded w-4/5"></div>
</div>

<div className="flex space-x-2 mb-4">
{[...Array(3)]?.map((_, i) => (
<div key={i} className="h-6 w-16 bg-muted rounded"></div>
))}
</div>

<div className="flex items-center justify-between pt-4 border-t border-border">
<div className="flex space-x-2">
<div className="h-8 w-24 bg-muted rounded"></div>
<div className="h-8 w-28 bg-muted rounded"></div>
</div>
<div className="h-6 w-16 bg-muted rounded-full"></div>
</div>
</div>
))}
</div>
);
};


export { LoadingState };